import {FC} from "react";

const Heading: FC = (props) => {
    return (
        <>
            <h3 className='text-2xl font-bold mb-2 flex items-center space-x-2'>{props.children}</h3>
            <hr className='mb-3 dark:border-slate-700 shadow-md'/>
        </>
    );
};

export default Heading;